import styled from "styled-components";

/* Five emoji choices; the selected one gets its mood color and its name below the row */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;

  .options {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    font-size: 30px;
    line-height: 1;
    background: var(--color-neutral-base);
    border: 2px solid transparent;
    border-radius: 12px;
    opacity: 0.55;
    filter: grayscale(0.6);
    transition:
      opacity 0.15s,
      filter 0.15s,
      transform 0.15s;

    &:hover {
      opacity: 0.85;
      filter: none;
    }

    &.active {
      opacity: 1;
      filter: none;
      transform: scale(1.06);
    }

    &.value-1.active {
      background: rgba(242, 60, 66, 0.2);
      border-color: #f23c42;
    }
    &.value-2.active {
      background: rgba(248, 106, 71, 0.2);
      border-color: #f86a47;
    }
    &.value-3.active {
      background: rgba(255, 163, 34, 0.2);
      border-color: #ffa322;
    }
    &.value-4.active {
      background: rgba(190, 207, 54, 0.2);
      border-color: #becf36;
    }
    &.value-5.active {
      background: rgba(111, 192, 49, 0.2);
      border-color: #6fc031;
    }

    @media (max-width: 340px) {
      width: 46px;
      height: 46px;
      font-size: 26px;
    }
  }

  .label {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--color-neutral-white);
  }
`;
